export default __webpack_public_path__ + "static/media/upload-arrow.34e14aa2.svg";